<header class="dialog__header">
  <h2 class="dialog__title">Status Workflow</h2>
</header>
<mat-dialog-content fxLayout="column">
  <img
    class="status-workflow-dialog__image"
    alt="Status Workflow"
    [src]="image | fileHash"
  />
</mat-dialog-content>
<footer class="dialog__footer">
  <button
    procure-button
    (click)="onClose()"
  >
    Close
  </button>
</footer>
